import { Suspense } from 'react';
import {
  filteredPlayerGamesAtom,
  playerGamesBySeasonAtom,
  playerSelectedGamesAtom,
} from '@/atoms/filters/player/playerGames';
import { unwrappedPlayerAggsMinutesPlayedAtom } from '@/atoms/queries/player/playerMinsPlayed';
import { playerCyclesOrderedAtom } from '@/atoms/queries/players';
import { RadarFilterCompetitionSummary } from '@/components/radar/filterSummaries/RadarFilterCompetitionSummary';
import { RadarFilterGameSummary } from '@/components/radar/filterSummaries/RadarFilterGameSummary';
import { RadarFilterMinsSummary } from '@/components/radar/filterSummaries/RadarFilterMinsSummary';
import { RadarFilterPositionSummary } from '@/components/radar/filterSummaries/RadarFilterPositionSummary';
import { RadarFilterSeasonSummary } from '@/components/radar/filterSummaries/RadarFilterSeasonSummary';
import { RadarFilterTeamSummary } from '@/components/radar/filterSummaries/RadarFilterTeamSummary';

export const PlayerFiltersSummary = () => (
  <Suspense>
    <div data-testid="player-radar-filter-summary" className="grid gap-2 grid-cols-1 @md:grid-cols-[1fr_2fr_1fr]">
      <RadarFilterMinsSummary minutesAtom={unwrappedPlayerAggsMinutesPlayedAtom} />
      <RadarFilterCompetitionSummary
        filteredGamesDataAtom={filteredPlayerGamesAtom}
        selectedGamesAtom={playerSelectedGamesAtom}
        orderedCyclesAtom={playerCyclesOrderedAtom}
      />
      <RadarFilterSeasonSummary
        filteredGamesDataAtom={filteredPlayerGamesAtom}
        selectedGamesAtom={playerSelectedGamesAtom}
      />
    </div>
    <div className="grid gap-2 grid-cols-1 @md:grid-cols-3">
      <RadarFilterTeamSummary
        filteredGamesDataAtom={filteredPlayerGamesAtom}
        selectedGamesAtom={playerSelectedGamesAtom}
      />
      <RadarFilterGameSummary
        gamesGroupedBySeasonAtom={playerGamesBySeasonAtom}
        selectedGamesAtom={playerSelectedGamesAtom}
      />
      <RadarFilterPositionSummary />
    </div>
  </Suspense>
);
